import React, { Component } from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import imgHero from "../images/gfx/hero-article.jpg"
import imgMobileHero from "../images/gfx/mobile-hero-1.jpg"


import imgShuttleVision from "../images/gfx/shuttlevision-cctv-school-bus-ticket.jpg"
import imgPayByBankList from "../images/gfx/pay-by-bank-list.png"
import imgProfileChrisBell from "../images/chris-bell-profile-square.jpg"
import "./index.css";
import "./case-study.css";
import "./article.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Contact from "../components/contact"
import Footer from "../components/footer"
import Nav from "../components/nav"

class BlogPage extends Component {

  componentDidMount(){
    AOS.init({
      duration : 2000
    });
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="ShuttleVision: Connecting school bus ticketing with CCTV" />
        <Nav activeTab="blog" />
        <div>
          <div className="blog case-study">

              <div className="hero-article" style={{ backgroundImage: `url(${imgHero})`, backgroundColor: '#063a70', backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundPosition: 'left center' }}>
                <h1 className="blog-headline">ShuttleVision: Connecting school bus ticketing with CCTV</h1>
              </div>

              <div className="mobile-hero-article" style={{ backgroundImage: `url(${imgMobileHero})`, backgroundColor: '#084e96', backgroundSize: '100% auto', backgroundRepeat: 'no-repeat', backgroundPosition: 'center top' }}>
                <h1 className="blog-headline">ShuttleVision: Connecting school bus ticketing with CCTV</h1>
              </div>

              <div className="blog">
                <div className="article">
                  <div className='article-intro article-inner'>
                    <p>ShuttleVision is a new safeguarding and incident investigation solution that connects passenger ticket scan data and vehicle tracking with CCTV footage.
                    </p>
                    <p>Developed through a new partnership with CCTV specialist Centrad, the integration enables greater visibility and context around all important events logged on each journey.
                    </p>
                    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}><iframe src="https://player.vimeo.com/video/1234317830?h=78fea20a25&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="ShuttleVision launch"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
                  </div>
                  <div className='article-inner'>
                    <h2>Connecting ticket scans with CCTV footage</h2>
                    <p>When reviewing a ticket scan in the ShuttleID platform, operators can directly access footage from the moments before and after a passenger boards, helping them investigate suspected fare evasion attempts, safeguarding concerns, passenger complaints and other incidents more quickly and effectively.</p>
                    <p>
                      The integration uses the cloud-based Centrad Platform, removing the need for operators to manually retrieve CCTV recordings from individual vehicles. Relevant footage can instead be accessed almost instantly, significantly reducing the time required to investigate an incident.
                    </p>
                    <p><img src={imgShuttleVision} alt="ShuttleVision" /></p>

                    <h2>Compatible with existing CCTV systems</h2>
                    <p>The Centrad Platform supports cameras from a range of CCTV manufacturers, meaning ShuttleVision is not limited to operators using Centrad hardware. Operators with compatible existing camera systems from other suppliers can also benefit from the integration.</p>
                    <p>Geoff Cross, Managing Director of Centrad, said:</p>
                    <p>“For too long, operators have had to piece together information from different systems when investigating incidents. By bringing ticketing data and vehicle CCTV footage together, we're making that process much quicker and easier, while helping operators improve passenger safety and safeguarding. We're delighted to be working with ShuttleID to bring this solution to market, particularly as it can also benefit operators with existing compatible onboard CCTV systems.”</p>
                    <h2>Complete safeguarding solution</h2>
                    <p>The launch strengthens ShuttleID’s wider safeguarding suite, which includes passenger scan logs, vehicle tracking, service alerts and parent boarding notifications. Together, these tools provide operators with greater visibility across their services, helping them protect passengers and investigate incidents faster.
</p>
                    <p>Chris Bell, ShuttleID Director, commented: </p>
                    <p>“ShuttleVision is a natural extension of our safeguarding technology and another step towards giving operators a complete picture of what is happening across their services. It’s an integration that has been years in the making and working with a forward-thinking partner like Centrad has finally unlocked this capability.”</p>
                    <p>ShuttleID will exhibit ShuttleVision at Euro Bus Expo, NEC (Birmingham) from Nov 3-5, on stand 228. More information about ShuttleVision can be requested by contacting ShuttleID at <a className="link" href="mailto:info@shuttleid.uk">info@shuttleid.uk</a> or calling 0333 344 9868.</p>
                    <div className='author' style={{ border: '1px solid #d5e6f5', background: '#f3f9ff', marginBottom: '10px' }}>
                      <div className='author__img'>
                        <img src={imgProfileChrisBell} alt="Chris Bell" />
                      </div>
                      <div className='author__quote' style={{  }}>
                        <p style={{ marginBottom: 10 }}><strong>About the author</strong></p>
                        <p style={{ marginBottom: 10 }}>Chris Bell is a director at ShuttleID; the affordable, digital bus pass and ticketing system that keeps you in control.</p>
                        <p style={{ marginBottom: 10 }}>During a 20 year career in technology, Chris worked on many systems for coach companies and saw the issues of managing home-to-school first hand, leading to the launch of ShuttleID in 2019.</p>
                        <p style={{ margin: 0 }}>Email: <a className="link" href="mailto:info@shuttleid.uk">info@shuttleid.uk</a> | Phone: 0333 344 9868</p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <Contact />
            </div>
        </div>
        <Footer />
      </Layout>
    );
  }
};

export default BlogPage